const TRANSLIT = {
  en: {
    'q': 'й',
    'w': 'ц',
    'e': 'у',
    'r': 'к',
    't': 'е',
    'y': 'н',
    'u': 'г',
    'i': 'ш',
    'o': 'щ',
    'p': 'з',
    'a': 'ф',
    's': 'ы',
    'd': 'в',
    'f': 'а',
    'g': 'п',
    'h': 'р',
    'j': 'о',
    'k': 'л',
    'l': 'д',
    'z': 'я',
    'x': 'ч',
    'c': 'с',
    'v': 'м',
    'b': 'и',
    'n': 'т',
    'm': 'ь',
    '{': 'х',
    '[': 'х',
    '}': 'ъ',
    ']': 'ъ',
    ':': 'ж',
    ';': 'ж',
    '\'': 'э',
    '"': 'э',
    ',': 'б',
    '.': 'ю',
    '/': '.'
  },
  ru: {
    'й': 'q',
    'ц': 'w',
    'у': 'e',
    'к': 'r',
    'е': 't',
    'н': 'y',
    'г': 'u',
    'ш': 'i',
    'щ': 'o',
    'з': 'p',
    'ф': 'a',
    'ы': 's',
    'в': 'd',
    'а': 'f',
    'п': 'g',
    'р': 'h',
    'о': 'j',
    'л': 'k',
    'д': 'l',
    'я': 'z',
    'ч': 'x',
    'с': 'c',
    'м': 'v',
    'и': 'b',
    'т': 'n',
    'ь': 'm',
    'х': '[',
    'ъ': ']',
    'ж': ':',
    'э': '"',
    'б': ',',
    'ю': '.',
    '.': '/'
  }
};
// eslint-disable-next-line no-useless-escape
const EN_REGEX = /^[~`!@#$%^&*()_ +=[\]\\{}|;':",.\/<>?a-zA-Z0-9-]+$/;
// eslint-disable-next-line no-useless-escape
const RU_REGEX = /^[~`!@#$%^&*()_ +=[\]\\{}|;':",.\/<>?а-яА-ЯЁё0-9-]+$/;

export { EN_REGEX, RU_REGEX, TRANSLIT };
